import React from 'react';

const SurveyAnswers = () =>{
    return(
        <>
        <h1>Answer surveys here!!</h1>
        </>
    )
}

export default SurveyAnswers